import React from 'react'
import PropTypes from 'prop-types'
import { COLORS } from 'utils/styleHelpers'

const RotateLeftIcon = ({ height, width, color }) => (
	<svg height={height} viewBox="0 0 40 40" width={width} xmlns="http://www.w3.org/2000/svg">
		<defs>
			<path
				d="M38.41 27.76C36.82 31.46 34.57 33.5 34.14 34.14C31.46 36.82 28.4 37.98 27.76 38.41C24.06 40 20.78 39.84 20 40C15.52 40 12.34 38.3 11.48 38.11C7.45 36.22 5.3 33.32 4.61 32.79C4.43 32.53 4.46 32.26 4.44 32.2C4.45 31.98 4.52 31.81 4.66 31.67C6.8 29.51 7.99 28.31 8.23 28.07C8.49 27.84 8.82 27.86 8.88 27.84C9.3 27.89 9.42 28.12 9.48 28.15C11.38 30.63 13.67 31.6 14.14 31.98C16.9 33.33 19.41 33.2 20 33.33C22.71 33.33 24.65 32.38 25.17 32.28C27.63 31.22 29 29.71 29.43 29.43C31.22 27.63 31.99 25.6 32.28 25.17C33.33 22.71 33.23 20.52 33.33 20C33.33 17.29 32.38 15.35 32.28 14.83C31.22 12.37 29.71 11 29.43 10.57C27.63 8.78 25.6 8.01 25.17 7.72C22.71 6.67 20.52 6.77 20 6.67C17.45 6.67 15.59 7.5 15.1 7.59C13.54 8.21 12.15 9.09 10.94 10.23C13.08 12.39 14.27 13.59 14.51 13.83C15.31 14.61 14.83 15.45 14.87 15.63C14.57 16.32 14.06 16.67 13.33 16.67C6.33 16.67 2.44 16.67 1.67 16.67C0.99 16.67 0.61 16.22 0.49 16.17C0.16 15.84 0 15.45 0 15C0 8 0 4.11 0 3.33C0 2.24 0.94 1.95 1.04 1.8C1.72 1.5 2.32 1.62 2.84 2.16C4.87 4.18 6 5.3 6.22 5.52C9.01 2.89 11.95 1.85 12.59 1.45C16.17 0 19.26 0.14 20 0C24.06 0 26.98 1.43 27.76 1.59C31.46 3.18 33.5 5.43 34.14 5.86C36.82 8.54 37.98 11.6 38.41 12.24C39.47 14.7 40 17.29 40 20C39.05 24.66 38.52 27.24 38.41 27.76Z"
				id="g7vHYLruj0"
			/>
		</defs>
		<use fill={COLORS.GREEN} xlinkHref="#g7vHYLruj0" />
	</svg>
)

RotateLeftIcon.propTypes = {
	color: PropTypes.string,
	height: PropTypes.number,
	width: PropTypes.number,
}
RotateLeftIcon.defaultProps = {
	color: COLORS.GREEN,
	height: 40,
	width: 40,
}

export default RotateLeftIcon
